import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { P, H, H1, H2, H3 } from '@components/shared/Typography';

interface Props {
  message: string;
}

const SuccessMessage: React.FC<Props> = ({ message }) => <Container>{message}</Container>;

export default SuccessMessage;

const Container = styled.div`
  display: flex;
  padding: 10px 20px;
  width: 100%;
  background: ${Colors.sage};
  border-radius: 2px;
  border: 1px solid #a2bbac;
  color: ${Colors.forestGreen};

  font-family: BrownStd;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
`;
